import React from "react";
import "./active.css";

const Active = ({ onChange }) => {
  return (
    <div className="published_Deative_transprant_body">
      <div className="published_Deative_preview_container">
        <img
          className="deactive_closeBtn"
          src="/images/cross-circle3.svg"
          alt=""
          onClick={(e) => onChange(false)}
        />
        <div className="col-12 deactivate_msg">
          Are you sure you want to activate this assessmet?
        </div>
        <div className="row col-12 publish_deactive_btnBox">
          <div className="col-sm-5 my-1 deactive_sure_btn">Yes</div>
          <div
            className="col-sm-5 my-1  deactive_sure_btn"
            onClick={(e) => onChange(false)}
          >
            No
          </div>
        </div>
      </div>
    </div>
  );
};

export default Active;
